import { NgModule } from '@angular/core';
import { ProductPriceLabelComponent } from './product-price-label.component';
import { CommonModule } from '@angular/common';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [ProductPriceLabelComponent],
    exports: [ProductPriceLabelComponent],
    imports: [
        CommonModule,
        TranslationModule
    ]
})
export class ProductPriceLabelModule {

}
